import React, { useState } from 'react';
import { cn } from '../../utils/classUtils';
import { AnimatedDiv } from './AnimatedDiv';
import NeoLeoPanelContainer from './NeoLeoPanelContainer';

interface NeoLeoMobileActionBarProps {
  isOpen: boolean;
  onClose: () => void;
}

const NeoLeoMobileActionBar: React.FC<NeoLeoMobileActionBarProps> = ({
  isOpen,
  onClose,
}) => {
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);

  React.useEffect(() => {
    if (!isOpen && isClosing) {
      const timer = setTimeout(() => {
        setIsClosing(false);
      }, 200);
      return () => clearTimeout(timer);
    }
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen, isClosing]);

  const handleClose = () => {
    setIsClosing(true);
    onClose();
  };

  return (
    <AnimatedDiv visible={isOpen} animationDuration={200}>
      <div
        className={cn(
          'fixed inset-0 z-50 bg-primary-navy md:hidden',
          isOpen && !isClosing ? 'animate-slide-up' : 'animate-slide-down',
        )}
      >
        <NeoLeoPanelContainer
          setShowHistory={setShowHistory}
          showHistory={showHistory}
          onClose={handleClose}
          isFullScreen
          isMobile
        />
      </div>
    </AnimatedDiv>
  );
};

export default NeoLeoMobileActionBar;
